import { initialPaginatorState, PaginatorInterfaceState } from '../state/paginator.state';
import { EPaginatorActions, PaginatorActions } from '../actions/paginator.actions';

export function paginatorReducer(state: PaginatorInterfaceState = initialPaginatorState, action: PaginatorActions): PaginatorInterfaceState {
  switch (action.type) {
    case EPaginatorActions.UpdatePaginator: {
      return { ...state, paginator: action.payload };
    }

    default:
      return initialPaginatorState;
  }
};
